import { Brand, Model, PartnerType } from '../models/brand.interface';
import { Environment } from '../models/environment.type';
import { MachineType } from '../models/machine-type.interface';

export const filterBrandsByFirstCharacter = (brands: Brand[],  character: string): Brand[] => {
  
  switch(character){
    case '0-9':
      return brands.filter((brand:Brand) => {
        return /^\d/.test(brand.name.toLowerCase());
      });

    case 'PARTNER':
      return brands

    default:
      return brands.filter((brand:Brand) => {
        return brand.name.toLowerCase().startsWith(character);
      });
  }
};

export const filterModelsByEnvironment = (
  models: Model[],
  filter: Environment | 'embedded'
): Model[] => {
  if (filter === 'all') {
    return models;
  }

  const filterToProperty = {
    ios: 'isIos',
    android: 'isAndroid',
    embedded: 'embeddedCompatibility',
  };
  const property = filterToProperty[filter];

  return models.filter((model) => {
    return model[property];
  });
};

export const filterModelsByEquipment = (
  models: Model[],
  filters: (MachineType | 'all')[]
): Model[] => {
  if (filters.includes('all')) {
    return models;
  }

  return models.filter((model) => {
    return filters
      .map((filter: MachineType) => filter.id)
      .includes(model.machineType.id);
  });
};
